module.exports = __webpack_public_path__ + "images/142_640.jpg";